import MyAnimations from './MyAnimations';

export default MyAnimations;
